module.exports = __webpack_public_path__ + "img/perso_ph.f2dff8fa.png";